const cartStorageKey = 'propickleball_cart_id';

export function loadCartId(): string | null {
  try {
    return window.localStorage.getItem(cartStorageKey);
  } catch {
    return null;
  }
}

export function saveCartId(cartId: string): void {
  try {
    window.localStorage.setItem(cartStorageKey, cartId);
  } catch {
    // Local storage can be unavailable in strict privacy contexts.
  }
}

export function clearCartId(): void {
  try {
    window.localStorage.removeItem(cartStorageKey);
  } catch {
    // Local storage can be unavailable in strict privacy contexts.
  }
}
